<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-toolbar flat dense class="toolbar">
            <v-toolbar-title>Subjects Taught</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <br>
        <v-data-table v-if="inst_sub_taught_list!=''" :headers="headers" :items="bookList1" class="elevation-1 mytable" dense :search="search"> 
            <template v-slot:top class="pb-5">
                        <v-row>
                            <v-col cols="12" sm="1" md="1"></v-col>
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                        rounded dense outlined color="#0F2027" :label="header.text"
                                                        multiple clearable :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
        </v-data-table>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        props: {
            instid: Number,
        },
        data() {
            return {
                overlay: false,
                inst_sub_taught_list: [],
                snackbar_msg: "",
                color: "",
                snackbar: false,
                search: "",
                filterArr: [],
                filters: {
                    academicyear: [],
                    standard: [],
                    course_name: [],
                    divisionoffering: [],
                },
                headers: [
                    {
                        text: "Academic Year",
                        align: "left",
                        sortable: false,
                        value: "academicyear",
                    },
                    {
                        text: "Course",
                        align: "left",
                        sortable: false,
                        value: "course_name",
                    },
                    {
                        text: "Standard",
                        align: "left",
                        sortable: true,
                        value: "standard",
                    },
                    {
                        text: "Division",
                        align: "left",
                        sortable: true,
                        value: "divisionoffering",
                    },
                ],
            };
        },
        computed: {
            bookList1() {
                return this.inst_sub_taught_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        mounted() {
            this.getData();
        },
        methods: {
            getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.inst_sub_taught_list.map((d) => d[val]);
        },
            async getData() {
                const data = {
                    instid: this.instid,
                };
                this.overlay = true;
                try {
                    const res = await axios.post("/EmployeeProfile/getEmployeeSubjectTaughtDetails", data);
                    if (res.data.flag == "YES") {
                        this.inst_sub_taught_list = res.data.inst_sub_taught_list;
                        this.overlay = false;
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                }
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
    
</style>
